module.exports = __webpack_public_path__ + "media/images/brand/app_text-c9dc227f3696bb1a5320be2e9f4bf368.png";